import Reactotron from 'reactotron-react-js';
import { reactotronRedux } from 'reactotron-redux';

if (process.env.NODE_ENV === 'development') {
  const tron = Reactotron.configure()
    .use(reactotronRedux())
  .connect();

  tron.clear();
  console.tron = tron;
}

// Reactotron.configure().connect();



// WEBPACK FOOTER //
// ./src/config/ReactotronConfig.js